import { Navbar } from "@/components/Navbar";
import { DashboardStats } from "@/components/dashboard/DashboardStats";
import { StepwiseTATPerformance } from "@/components/dashboard/StepwiseTATPerformance";
import { WardwiseTATPerformance } from "@/components/dashboard/WardwiseTATPerformance";

const Dashboard = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <main className="max-w-[1400px] mx-auto px-3 sm:px-4 py-3 sm:py-4 space-y-4">
        <DashboardStats />

        {/* TAT Performance Section - Side by Side */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <StepwiseTATPerformance />
          <WardwiseTATPerformance />
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
